import { AddressDto, EmailDto, PhoneDto } from "./address"
import { WardDto } from "./WardDto"

export class CarehomeDto {
    id: string;
    unitId: string;
    name: string;
    active: boolean;
    statusFrom: Date;
    electronicReorderingEnabled: boolean;
    whenCreated: Date;
    whenUpdated: Date;
    addresses:  AddressDto[];
    emails:     EmailDto[];
    phones:     PhoneDto[];
    notes: string;
    wards: WardDto[];
}




// WEBPACK FOOTER //
// ./ClientApp/dto/carehomedto.ts